import {
  ActionIcon,
  Anchor,
  Badge,
  Box,
  Breadcrumbs,
  Button,
  Col,
  Container,
  Divider,
  FileInput,
  Flex,
  Grid,
  Modal,
  NumberInput,
  Select,
  Text,
  TextInput,
  Tooltip,
} from "@mantine/core";
import { useForm } from "@mantine/form";
import { useMediaQuery } from "@mantine/hooks";
import { openConfirmModal } from "@mantine/modals";
import {
  IconBoxSeam,
  IconCash,
  IconCurrency,
  IconDownload,
  IconEdit,
  IconEye,
  IconFile,
  IconFile3d,
  IconPackage,
  IconPaperBag,
  IconPlus,
  IconPrinter,
  IconPrinterOff,
  IconPrison,
  IconTrash,
  IconTruckDelivery,
  IconWallet,
} from "@tabler/icons";
import { IconCashBanknote, IconCirclePlus } from "@tabler/icons-react";
import AddPaymentReceipt from "components/AddPaymentReceipt";
import FloatingMenu from "components/FloatingMenu";
import { InvoicePrintA4 } from "components/InvoicePrintA4";
import printTemplate from "components/InvoicePrintComponent";
import { PrintModal } from "components/PrintModal";
// import PaymentReceiptModal from "components/PaymentReceiptModal";
import ViewPaymentReceipts from "components/ViewPaymentReceipts";
import { MantineReactTable } from "mantine-react-table";
import moment from "moment";
import { getCounterId, hasPermission, isCounterAdmin } from "pages/Auth/permissionGuard";
import { counters_api } from "pages/master/counter/counter.service";
import { getAlteredCounters } from "pages/master/customers/helperFunctions";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { CSVLink } from "react-csv";
import BarcodeScannerComponent from "react-qr-barcode-scanner";
import { useQuery, useQueryClient } from "react-query";
import { useNavigate } from "react-router";
import { useReactToPrint } from "react-to-print";
// import {api_getUsers,} from "./users.service.js";
import {
  getBodyContent,
  getCsvContent,
  getCustomId,
  getFields,
  getFilterPayload,
  getHeaders,
  getTotal,
} from "services/filterHelperFunctions";

import { invoice_api } from "./invoice.service";
import AppBreadcrumb from "../../../components/AppBreadcrumb";
import { api_addUser, api_filter } from "../../../services/master.service";
import { showErrorToast, showSuccessToast } from "../../../utilities/Toast";
import { api_addPaymentReceipt, api_getPaymentReceipt } from "../payment-receipt/paymentReceipt.service";

export default function InvoiceList(props) {

  const enrichInvoicesWithReceipts = async (rows) => {
    return Promise.all(
      (rows || []).map(async (row) => {
        try {
          const receiptRes = await api_getPaymentReceipt(counter, row.id);

          const receiptData = receiptRes?.data;
          const total_receipt_amount = Array.isArray(receiptData)
            ? receiptData.reduce((sum, { amount }) => sum + Number(amount || 0), 0)
            : Number(receiptData?.amount || 0);

          const total = Number(row.total || 0);
          const balance = Math.max(0, total - total_receipt_amount);
          // console.log("balance", balance, total, total_receipt_amount);
          const modes = Array.isArray(receiptData) ? receiptData.map(r => r.mode_of_payment).join(", ") : receiptData?.mode_of_payment || "";
          const customer = Array.isArray(receiptData)
            ? receiptData[0]?.customer || row.customer || null // take from first receipt if available
            : receiptData?.customer || row.customer || null;


          return {
            ...row,
            receipts: Array.isArray(receiptData) ? receiptData : receiptData ? [receiptData] : [],
            amount: total_receipt_amount,
            // balance_amount: balance,
            mode_of_payment: modes, // add this
            customer,
          };
        } catch (err) {
          console.error("Receipt API error for invoice", row?.id, err);
          return {
            ...row,
            receipts: [],
            amount: 0,
            balance_amount: Number(row.total || 0),
            customer: row.customer || null,
          };
        }
      })
    );
  };

  const queryClient = useQueryClient();
  const navigate = useNavigate();
  let isMobileScreen = useMediaQuery("(max-width: 768px)");

  // START : States
  const [barcodeData, setBarcodeData] = useState("Not Found");
  const [modalOpenedBarcode, setModalOpenedBarcode] = useState(false);
  const [head, setHead] = useState([]);
  const [body, setBody] = useState([]);
  const [foot, setFoot] = useState([]);
  const [csv, setCsv] = useState([]);
  const [isCsv, setIsCsv] = useState(false);
  const [invoiceA4, setInvoiceA4] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [addProductModalOpened, setAddProductModalOpened] = useState(false);
  // END : States

  // STARTS : States
  const [userFormVisible, setUserFormVisible] = useState(false);
  const [loginError, setLoginError] = useState(null);
  const [loginErrorMessage, setLoginErrorMessage] = useState(false);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(false);
  const [paymentReceiptFormVisible, setPaymentReceiptFormVisible] = useState(false);
  const [invoicesData, setInvoicesData] = useState([]);
  const [viewPaymentReceiptModalOpened, setViewPaymentReceiptModalOpened] = useState(false);
  const [viewPaymentReceiptId, setViewPaymentReceiptId] = useState({});

  // Refactoring payment receipts
  const [invoiceId, setInvoiceId] = useState(false);
  const [selectedInvoice, setSelectedInvoice] = useState(null);
  const [addPaymentReceiptOpened, setaddPaymentReceiptOpened] = useState(false);
  //

  const [countersList, setCountersList] = useState([]);
  const [counter, setCounter] = useState(isCounterAdmin() ? getCounterId() : "");
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });
  const [counterData, setCounterData] = useState([]);
  const [columnFilters, setColumnFilters] = useState([]);
  const [filename, setFilename] = useState("file");
  const [headingText, setHeadingText] = useState("INVOICE");
  const [creditTotal, setCreditTotal] = useState(0);
  const [todayTotal, setTodayTotal] = useState(0);
  const [filteredTotal, setFilteredTotal] = useState(0);
  console.log("columnFilters", columnFilters);
  const role = localStorage.getItem("role");


  const [idForPrint, setIdForPrint] = useState(null)

  const counter_data = useQuery({
    queryKey: ["counters-data-list"],
    queryFn: () => counters_api.get(),
    onSuccess: data => {
      setCountersList(getAlteredCounters(data.data));
      setCounterData(data.data);
    },
  });

  //Reset Pagination to 0
  useEffect(() => {
    setPagination(p => ({ ...p, pageIndex: 0 }));
  }, [columnFilters]);


  // const users = useQuery("users", api_getUsers, {
  //   refetchOnWindowFocus: false,
  // });
  const invoices = useQuery({
    queryKey: ["orders-data", pagination.pageIndex, pagination.pageSize, counter, columnFilters],
    queryFn: async () => {
      if (columnFilters.length > 0) {

        return printFilter(false); // Call printFilter without setting CSV
      } else {
        const res = await invoice_api.get_invoices(counter, null, pagination.pageIndex + 1, pagination.pageSize);

        console.log("TESTING (raw invoices)", res.data);
        // console.log("res", res);
        console.log("todayStats", res?.todaysStats["total"], res?.todaysStats["editable"], res?.todaysStats["pending"]);
        setTodayTotal(res?.todayInvoiceTotal || 0);
        const total = res?.todaysStats["total"] || 0;
        const editable = res?.todaysStats["editable"] || 0;
        const pending = res?.todaysStats["pending"] || 0;
        setTodayStats({ total, pending, editable });

        localStorage.setItem("editable_invoices", JSON.stringify(editable));

        const enrichedData = await enrichInvoicesWithReceipts(res.data);
        const mergedData = res.data
          .map((row, i) => {
            const enriched = enrichedData[i] || {};

            return {
              ...row,
              ...enriched,
              user: row.user || "",  // from serializer
              username: row.username || "",       // from serializer
            };
          })
          .filter(row => !row.deleted);

        console.log("MERGED (invoices + receipts)", mergedData);

        return { data: mergedData, count: res?.count ?? mergedData.length };
      }
      // return invoice_api.get_invoices(pagination.pageIndex + 1, pagination.pageSize, counter);
    },
    keepPreviousData: true,
    onSuccess: data => {
      // console.log('qqq-24',data?.data)
      setData(data.data);
      // calculateTodayStats(data.data); 
    },
  });


  const openDeleteConfirmation = id => {
    openConfirmModal({
      title: "Please confirm delete invoice",
      children: (
        <Text size="sm">
          Are you sure you want to delete this invoice ? Everything related to this invoice will be
          deleted.
        </Text>
      ),
      labels: { confirm: "Delete Invoice", cancel: "Cancel" },
      onCancel: () => console.log("Cancel"),
      onConfirm: async () => await deleteInvoice(id),
      confirmProps: { color: "red" },
    });
  };

  const deleteInvoice = async id => {
    await invoice_api.delete_invoice(id).then(res => {
      console.log(res.data);
    });
    invoices.refetch();
  };
  const [todayStats, setTodayStats] = useState({
    total: 0,
    pending: 0,
    editable: 0
  });
  // const calculateTodayStats = (data) => {
  //   if (!data || !Array.isArray(data)) return;

  //   const today = new Date();
  //   const todayStart = new Date(today.getFullYear(), today.getMonth(), today.getDate());
  //   const todayEnd = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 23, 59, 59, 999);

  //   const todayInvoices = data.filter(invoice => {
  //     const invoiceDate = new Date(invoice.create_at);
  //     return invoiceDate >= todayStart && invoiceDate <= todayEnd;
  //   });

  //   const total = todayInvoices.length;
  //   // Use the same logic as isF6Invoice and Cell renderer
  //   const editable = todayInvoices.filter(invoice => 
  //     !invoice.delivered && 
  //     Number(invoice.balance_amount) > 0 &&
  //     Number(invoice.amount || 0) === 0
  //   ).length;

  //   const completed = todayInvoices.filter(invoice => 
  //     Number(invoice.balance_amount) < 1
  //   ).length;

  //   // Pending = Total - (Editable + Completed)
  //   const pending = total - (editable + completed);

  //   setTodayStats({ total, pending, editable });
  // };
  const isF6Invoice = (row) => {
    return (
      !row.delivered &&
      Number(row.balance_amount) > 0 &&
      Number(row.amount || 0) <= 0
    );
  };


  const columns = useMemo(
    () => [
      {
        header: "Invoice No.",
        accessorKey: "invoice_id",
        size: 50,
      },
      {
        accessorFn: originalRow => new Date(originalRow.create_at),
        id: "create_at",
        header: "Date",
        accessorKey: "create_at",
        size: 50,
        Cell: ({ cell }) => cell.getValue()?.toLocaleString("en-IN"),
        filterVariant: "date-range",
      },
      {
        header: "Customer",
        accessorKey: "user",
        size: 50,
      },
      {
        header: "User",
        accessorKey: "username",
        size: 50,
      },
      {
        header: "Amount",
        accessorKey: "total",
        filterVariant: "num-range",

        size: 50,
        Cell: ({ cell }) => (
          <span className="ls-1">₹ {cell.getValue().toFixed(2)?.toLocaleString("en-IN")}</span>
        ),
      },
      {
        header: "Payment Status",
        accessorFn: (row) => {
          if (!row.delivered && Number(row.balance_amount) > 0 && Number(row.amount || 0) <= 0)
            return "Editable";
          if (Number((row.balance_amount || 0).toFixed(0)) < 1) return "Completed";
          return "Pending";
        },

        id: "payment_status",
        size: 50,
        filterVariant: "select",
        mantineFilterSelectProps: {
          data: ["Completed", "Pending", "Editable"],
        },
        Cell: ({ row }) => {
          const original = row.original;

          let label = "Pending";
          let color = "red";

          if (isF6Invoice(original)) {
            label = "Editable";
            color = "yellow";
          } else if (Number(original.balance_amount) < 1) {
            label = "Completed";
            color = "green";
          }

          return (
            <Badge
              color={color}
              variant="filled"
              sx={{ width: "80%", textAlign: "center" }}
            >
              {label}
            </Badge>
          );
        },
      }

    ],
    []
  );

  const csvcolumns = useMemo(
    () => [
      {
        header: "Invoice No.",
        accessorKey: "invoice_id",
        size: 50,
      },
      {
        accessorFn: originalRow => new Date(originalRow.create_at),
        id: "create_at",
        header: "Date",
        accessorKey: "create_at",
        size: 50,
        Cell: ({ cell }) => cell.getValue()?.toLocaleString("en-IN"),
        filterVariant: "date-range",
      },
      {
        header: "Name",
        accessorKey: "user",
        size: 250,
      },
      // { 
      //   header: "User", 
      //   accessorKey: "username", 
      //   size: 250 },
      {
        header: "Phone Number",
        accessorKey: "phone_no",
        size: 250,
      },
      {
        header: "Amount",
        accessorKey: "total",
        filterVariant: "range",
        size: 50,
        Cell: ({ cell }) => (
          <span className="ls-1">₹ {Math.round(cell.getValue() || 0).toLocaleString("en-IN")}</span>
        ),
      },
      {
        header: "Balance",
        accessorKey: "balance_amount",
        size: 250,
        Cell: ({ cell }) => (
          <span>₹ {Math.round(cell.getValue() || 0).toLocaleString("en-IN")}</span>
        ),
      },
      {
        header: "Received",
        accessorKey: "amount",
        size: 250,
        Cell: ({ cell }) => (
          <span>₹ {Math.round(cell.getValue() || 0).toLocaleString("en-IN")}</span>
        ),
      },
      {
        header: "Rounded Value",
        accessorKey: "rounded_diff",
        size: 250,
      },
      {
        header: "Mode of Payment",
        accessorKey: "mode_of_payment",
        size: 250,
      },
    ],
    []
  );

  const openDeliveryConfirmation = id => {
    openConfirmModal({
      title: "Please confirm deliver invoice",
      children: <Text size="sm">This action cannot be undone.</Text>,
      labels: { confirm: "Deliver Invoice", cancel: "Cancel" },
      onCancel: () => console.log("Cancel"),
      onConfirm: async () => await deliverInvoice(id),
      confirmProps: { color: "primary" },
    });
  };

  const deliverInvoice = async id => {
    await invoice_api.deliver_invoice(id).then(res => {
      console.log(res.data);
      if (res.data.success) {
        showSuccessToast({
          title: "Success",
          message: res.data.message,
        });
        invoices.refetch();
      } else {
        showErrorToast({
          title: "Error",
          message: res.data.message,
        });
      }
    });
  };

  const printInvoice = async (id, markedDelivered) => {
    await invoice_api.get_invoice_print_data_by_id(id).then(res => {
      const data = res.data.data;

      const item = data.invoice_item.map(e => {
        return `<tr style="border-bottom: 1px dashed #ccc;">
            <td style="text-align: left; padding: 6px 0 6px 10px; vertical-align: top; white-space: normal; word-break: break-word;">
              <span style="font-weight: bold; font-size: 13px; color: #000; display: block;">${e.product}</span>
              <span style="font-size: 9.5px; color: #555; display: block; margin-top: 2px; white-space: nowrap;">
                ${e.varientSlug ? `${e.varientSlug} | ` : ""}<span style="font-size: 11px; font-weight: bold; color: #000;">BN: ${e.batch_no}</span> | Tax: ${e.tax}%
              </span>
            </td>
            <td style="text-align: right; padding: 6px 0; vertical-align: top; font-size: 13px; font-weight: bold;">
              ${e.qty}
            </td>
            <td style="text-align: right; padding: 6px 0; vertical-align: top; font-size: 13px;">
              ${e.rate.toFixed(2)}<br/>
              <span style="font-size: 10px; color: #777;">MRP: ${e.mrp.toFixed(2)}</span>
            </td>
            <td style="text-align: right; padding: 6px 10px 6px 0; vertical-align: top; font-size: 13px; font-weight: bold;">
              ${e.amount.toFixed(2)}<br/>
              <span style="font-size: 10px; color: #777; font-weight: normal;">Disc: ${e.discount}%</span>
            </td>
        </tr>`;
      });
      const qty = data.invoice_item.reduce((accumulator, currentValue) => {
        return accumulator + currentValue.qty;
      }, 0);
      const items = item.join("");
      const printWindow = window.open(""); // Changed to _self to open in same window
      printWindow.document.open();
      printWindow.document.write(printTemplate(data, items, moment, qty));
      printWindow.document.close();
      printWindow.print();

      if (!markedDelivered) {
        openDeliveryConfirmation(id);
      }

      printWindow.close();
    });
  };

  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  useEffect(() => {
    //console.log(head);
    if (body.length !== 0 && head.length !== 0) {
      if (!isCsv) {
        handlePrint();
        setBody([]);
        setHead([]);
      }
    }
    setIsCsv(false);
  }, [body, head]);

  // const get_text = html => {
  //   let div = document.createElement("div");
  //   div.innerHTML = html;
  //   let text = div.textContent || div.innerText || "";
  //   return text;
  //   //return parseFloat(text.replace(/[^0-9.]/g, ""));
  // };

  // const get_sum = removeAction => {
  //   const datatablebody = document
  //     .querySelector(".datatable-wrapper")
  //     ?.querySelector("tbody")
  //     ?.querySelectorAll("tr");
  //   let column_total = [];
  //   datatablebody?.forEach(e => {
  //     let row_total = [];
  //     const d = e?.querySelectorAll("td");
  //     d?.forEach((tag, i) => {
  //       if (!removeAction || d.length !== i + 1) {
  //         row_total.push(parseFloat(get_text(tag?.innerHTML).replace(/[^0-9.]/g, "")));
  //       }
  //     });
  //     column_total.push(row_total);
  //   });

  //   let total = [];
  //   column_total.map((e, i) => {
  //     e.map((h, index) => {
  //       if (i === 0) {
  //         total.push(h);
  //       } else {
  //         total[index] = h + total[index];
  //       }
  //     });
  //   });

  //   let nan_count = 0;
  //   total.map((e, i) => {
  //     if (isNaN(e)) {
  //       nan_count += 1;
  //     }
  //   });
  //   if (nan_count === total.length) {
  //     setFoot([]);
  //   } else {
  //     setFoot(total);
  //   }

  //   return total;
  // };

  // const print = removeAction => {
  //   var head_content = [];
  //   var body_content = [];
  //   const datatable = document
  //     .querySelector(".datatable-wrapper")
  //     ?.querySelector("thead")
  //     ?.querySelectorAll("th");
  //   datatable !== undefined &&
  //     datatable?.forEach((e, i) => {
  //       if (!removeAction || datatable.length !== i + 1) {
  //         head_content.push(e?.querySelector(".mantine-TableHeadCell-Content-Wrapper")?.innerText);
  //       }
  //     });

  //   const datatablebody = document
  //     .querySelector(".datatable-wrapper")
  //     ?.querySelector("tbody")
  //     ?.querySelectorAll("tr");
  //   datatablebody?.forEach(e => {
  //     let row = [];
  //     const d = e?.querySelectorAll("td");
  //     d?.forEach((tag, i) => {
  //       if (!removeAction || d.length !== i + 1) {
  //         row.push(get_text(tag?.innerHTML));
  //       }
  //     });
  //     body_content.push(row);
  //   });

  //   setHead(head_content);
  //   setBody(body_content);
  //   let csv_data = [];
  //   csv_data.push(head_content);
  //   body_content.map((e, i) => {
  //     csv_data.push(e);
  //   });
  //   const cols = [3];
  //   let sum = [];
  //   get_sum(removeAction).map((e, i) => {
  //     if (isNaN(e) || !cols?.includes(i, 0)) {
  //       sum.push("");
  //     } else {
  //       sum.push(e);
  //     }
  //   });
  //   csv_data.push(sum);
  //   setCsv(csv_data);
  // };

  const a4Ref = useRef();
  const handlePrintA4 = useReactToPrint({
    content: () => a4Ref.current,
    onAfterPrint: () => {
      if (idForPrint) {
        openDeliveryConfirmation(idForPrint);
      }
    }
  });

  useEffect(() => {
    if (invoiceA4 !== null) {
      handlePrintA4();
    }
  }, [invoiceA4]);

  const printInvoiceA4 = async (id, markedDelivered) => {
    await invoice_api.get_invoice_print_data_by_id(id).then(res => {
      const data = res.data.data;
      if (markedDelivered) {
        setIdForPrint(null)
      } else {
        setIdForPrint(id)
      }
      setInvoiceA4(data);
    });
  };

  // const printFilter = () => {
  //   const model = "Invoice";

  //   const appendData = [
  //     { id: "invoice_id", append: "" },
  //     { id: "create_at", append: "" },
  //     { id: "first_name", append: "user__", replace_id: "user" },
  //     { id: "total", append: "" },
  //   ];
  //   const custom = getCustomId(columns, columnFilters, appendData);
  //   const filter = getFilterPayload(custom?.columns, custom?.columnFilters);
  //   const fields = getFields(custom?.columns);

  //   api_filter(model, filter, fields)
  //     .then(res => {
  //       if (res.success) {
  //         console.log('qqq-23',res.data);
  //         const head_content = getHeaders(columns);
  //         const body_content = getBodyContent(res.data, fields);
  //         const csv_content = getCsvContent(head_content, body_content, ["INVOICE"]);
  //         const columnTotalIndex = [3];
  //         const foot_content = getTotal(body_content, columnTotalIndex);
  //         setFilename(
  //           "INVOICE" +
  //             "_" +
  //             countersList?.find(e => e.id === counter)?.label +
  //             "_" +
  //             new Date().toLocaleDateString() +
  //             ".csv"
  //         );
  //         setCsv(csv_content);
  //         setHead(head_content);
  //         setBody(body_content);
  //         setFoot(foot_content);
  //       } else {
  //         showErrorToast({ title: "Error", message: res.message });
  //       }
  //     })
  //     .catch(e => {
  //       showErrorToast({ title: "Error", message: e.message });
  //     });
  // };


  // Utility: build rows for CSV (array of arrays)
  const buildCsvRows = (data, appendData) => {
    return data.map(row => {
      return appendData.map(col => {
        const field = col.replace_id || col.id;
        return row[field] ?? "";
      });
    });
  };


  const printFilter = async (forCsv = true) => {
    const model = "Invoice";
    const appendData = [
      { id: "invoice_id", append: "" },
      { id: "create_at", append: "" },
      { id: "first_name", append: "user__", replace_id: "user" },
      { id: "customer", append: "" },
      { id: "total", append: "" },
      { id: "balance_amount", append: "" },
      { id: "amount", append: "" },
      { id: "rounded_diff", append: "" },
      { id: "mode_of_payment", append: "" },
      { id: "payment_status", append: "" },
      // 👇 conditionally added
  ...(forCsv === false
    ? [{ id: "username", append: "invoiced_user__", replace_id: "username" }]
    : []),
    ];

    const custom = getCustomId(csvcolumns, columnFilters, appendData); //changes csvcolumns to colunms
    const filterPayload = getFilterPayload(custom?.columns, custom?.columnFilters);
    const fields = getFields(custom?.columns);
    console.log("677 filter", filterPayload)
    console.log("678 custom", custom)
    console.log(csvcolumns, columnFilters, appendData)

    try {
      // const res = await api_filter(model, filterPayload, fields, "InvoiceSerializer");
      const res = await api_filter(model, filterPayload, fields, "InvoiceSerializer", counter, pagination.pageIndex + 1, pagination.pageSize, forCsv);
      if (!res.success) {
        showErrorToast({ title: "Error", message: res.message });
        return { data: [], count: 0 };
      }
      // const formatDate = (dateValue) => {
      //   if (!dateValue) return "";
      //   const d = new Date(dateValue);
      //   return `${d.getDate()}-${d.getMonth() + 1}-${d.getFullYear()}`;  // D-M-YYYY
      // };

      setFilteredTotal(res?.total || 0);
      const enrichedData = await enrichInvoicesWithReceipts(res.data);
      const mergedData = res.data
        .map((row, i) => {
          const enriched = enrichedData[i] || {};
          const totalAmount = Number(enriched.total || 0);
          const roundedAmount = Math.round(totalAmount);
          const difference = roundedAmount - totalAmount;
          const formattedDifference = difference.toFixed(2);
          const signedDifference = (difference > 0 ? "+" : "") + formattedDifference;
          const receivedRounded = Math.round(Number(enriched.amount || 0));
          const balanceRounded = Math.round(Number(row.balance_amount || 0));

          return {
            ...row,
            ...enriched,
            user: row.user || "",
            username: row.username || "",
            // create_at: formatDate(row.create_at),

            // ✅ rounded values for CSV rows
            amount: receivedRounded,            // Received
            balance_amount: balanceRounded,      // Balance

            rounded_diff: signedDifference,
          };

        })
        .filter(row => !row.deleted);

      // let mergedData = res.data
      // .map(row => ({
      //   ...row,
      //   user: row.user || "",
      //   username: row.username || "",
      //   balance_amount: Number(row.balance_amount || 0).toFixed(2),
      // }))
      // .filter(row => !row.deleted);
      // let filteredData = mergedData;
      let filteredData = mergedData.map(item => ({ ...item }));
      console.log("filter", filteredData, "mergedData", mergedData);
      columnFilters.forEach((f) => {
        const { id, value } = f;
        if (!value) return;

        // Date-range filter
        if (id === "create_at" && (value?.[0] || value?.[1])) {
          const start = value?.[0] ? new Date(value[0]) : null;
          const end = value?.[1] ? new Date(new Date(value[1]).setHours(23, 59, 59, 999)) : null;

          filteredData = filteredData.filter((row) => {
            const rowDate = new Date(row.create_at);

            if (start && end) {
              return rowDate >= start && rowDate <= end;
            } else if (start && !end) {
              return rowDate >= start;
            } else if (!start && end) {
              return rowDate <= end;
            }
            return true;
          });
        }
        else if (id === "payment_status") {
          filteredData = filteredData.filter((row) => {
            const delivered = (row.delivered);
            const balance = Number(row.balance_amount || 0);
            const amount = Number(row.amount || 0);

            let status;

            if (!delivered && balance > 0 && amount === 0) {
              status = "Editable";
            } else if (balance < 1) {
              status = "Completed";
            } else if (row.delivered && balance > 0) {
              status = "Pending";
            }

            const selected = Array.isArray(value) ? value[0] : value;
            return status === selected;
          });
        }


        // String filters (user, customer, etc.)
        else if (typeof value === "string") {
          filteredData = filteredData.filter((row) =>
            String(row[id] || "").toLowerCase().includes(value.toLowerCase())
          );
        }
        // Numeric / select filters
        else if (typeof value === "number" || Array.isArray(value)) {
          filteredData = filteredData.filter(
            (row) => String(row[id]) === String(value)
          );
        }
      });
      //     filteredData = filteredData.map((row) => ({
      //   ...row,
      //   create_at: row.create_at
      //     ? moment(row.create_at).format("DD-MM-YYYY")
      //     : "",
      // }));

      if (forCsv) {
        // use filteredData instead of mergedData
        const head_content = getHeaders(csvcolumns);
        filteredData = filteredData.map((row) => ({
          ...row,
          create_at: row.create_at
            ? moment(row.create_at).format("DD-MM-YYYY")
            : "",
        }));
        const body_content = buildCsvRows(filteredData, appendData);

        // ✅ calculate totals based on filtered data
        const totalAmount = filteredData.reduce((sum, row) => sum + (Number(row.total || 0)), 0).toFixed(2);
        const totalReceived = filteredData.reduce((sum, row) => sum + Math.round(Number(row.amount || 0)), 0);
        const totalBalanceAmount = filteredData.reduce((sum, row) => sum + Math.round(Number(row.balance_amount || 0)), 0);
        const totalRoundedAmount = filteredData.reduce((sum, row) => sum + (Number(row.rounded_diff || 0)), 0).toFixed(2);

        // 🧮 per-mode totals
        let totalCash = 0, totalCard = 0, totalUpi = 0, totalCredit = 0, totalGift = 0;

        filteredData.forEach(row => {
          row.receipts.forEach(receipt => {
            const mode = (receipt.mode_of_payment || "").toLowerCase();
            const amount = Math.round(Number(receipt.amount || 0));
            if (mode.includes("cash")) totalCash += amount;
            else if (mode.includes("card")) totalCard += amount;
            else if (mode.includes("upi")) totalUpi += amount;
            else if (mode.includes("credit")) totalCredit += amount;
            else if (mode.includes("gift")) totalGift += amount;
          });
        });

        // totals and breakdown rows
        body_content.push(Array(appendData.length).fill(""));
        body_content.push([
          "TOTAL", "", "", "",
          totalAmount,
          Math.round(totalBalanceAmount),
          Math.round(totalReceived),
          totalRoundedAmount,
          ""
        ]);

        const fmtINR = (v) => `₹${Math.round(Number(v || 0)).toLocaleString("en-IN")}`;
        const breakdownRow = (label, value) => {
          const r = Array(appendData.length).fill("");
          r[0] = label;
          r[6] = fmtINR(value);
          return r;
        };

        body_content.push(Array(appendData.length).fill(""));
        body_content.push(breakdownRow("Grand_Total(Cash)", totalCash));
        body_content.push(breakdownRow("Grand_Total(Card)", totalCard));
        body_content.push(breakdownRow("Grand_Total(Upi)", totalUpi));
        body_content.push(breakdownRow("Grand_Total(Credit)", totalBalanceAmount));
        body_content.push(breakdownRow("Grand_Total(Gift)", totalGift));
        body_content.push(breakdownRow("Grand_Total(All)", totalCash + totalCard + totalUpi + totalBalanceAmount + totalGift));

        // const csv_content = getCsvContent(head_content, body_content, [headingTitle]);
        const columnTotalIndex = [3];
        const foot_content = getTotal(body_content, columnTotalIndex);

        const dateFilter = columnFilters.find(f => f.id === "create_at");
        const userFilter = columnFilters.find(f => f.id === "username");


        // ✅ Helper to format date
        const formatDate = (d) =>
          `${String(d.getDate()).padStart(2, "0")}-${String(d.getMonth() + 1).padStart(2, "0")}-${d.getFullYear()}`;

        // Build usernamePart ONLY if username filter is applied
        let usernamePart = "";
        if (userFilter && userFilter.value) {
          // Prefer the actual username coming from the filtered results (backend)
          if (Array.isArray(filteredData) && filteredData.length > 0 && filteredData[0].username) {
            usernamePart = String(filteredData[0].username).trim().replace(/\s+/g, "_");
          } else {
            // fallback to whatever the UI filter contains (user typed)
            usernamePart = String(userFilter.value).trim().replace(/\s+/g, "_");
          }
          // keep casing as-is from backend; convert to safe filename
          usernamePart = usernamePart.toLowerCase();
        }
        // ✅ Extract date part if date range exists
        let datePart = "";
        if (dateFilter?.value?.[0] && dateFilter?.value?.[1]) {
          const start = new Date(dateFilter.value[0]);
          const end = new Date(dateFilter.value[1]);
          datePart = `${formatDate(start)}_to_${formatDate(end)}`;
        }

        // ✅ Build final filename first
        let finalFilename = "";
        if (usernamePart && datePart) {
          finalFilename = `invoice_${usernamePart}_${datePart}.csv`;
        } else if (usernamePart) {
          finalFilename = `invoice_${usernamePart}.csv`;
        } else if (datePart) {
          finalFilename = `invoice_${datePart}.csv`;
        } else {
          const today = new Date();
          finalFilename = `invoice_${formatDate(today)}.csv`;
        }

        // 🧾 Build heading text properly (must come AFTER finalFilename)
        let headingTitle = "INVOICE";

        const cleanParts = [];
        if (usernamePart) cleanParts.push(usernamePart.replace(/_/g, " "));
        if (datePart) cleanParts.push(datePart.replace(/_/g, " "));

        if (cleanParts.length > 0) {
          headingTitle = `INVOICE - ${cleanParts.join(" ")}`;
        }

        // ✅ Update React state for print and CSV
        setHeadingText(headingTitle);
        setFilename(finalFilename);

        // ✅ Build CSV content with dynamic heading
        const csv_content = getCsvContent(head_content, body_content, [headingTitle]);
        setCsv(csv_content);
        setHead(head_content);
        setBody(body_content);
        setFoot(foot_content);

      } else {
        // console.log("else", filteredData, res);
        // setFilteredTotal(res?.total || 0);
        return {
          data: res?.data,          // backend already paginated
          count: res?.count ?? filteredData.length,
        };
        // ✅ apply pagination before returning data to table
        // const start = pagination.pageIndex * pagination.pageSize;
        // const end = start + pagination.pageSize;

        // const paginatedData = filteredData.slice(start, end);

        // return {
        //   data: paginatedData,          // ONLY 10 rows (or pageSize)
        //   count: filteredData.length,   // total rows for pagination UI
        // };

        // return { data: filteredData, count: filteredData.length };
      }
    } catch (e) {
      showErrorToast({ title: "Error", message: e.message });
      return { data: [] };
    }
  };

  const csvRef = useRef();
  useEffect(() => {
    if (csv.length && isCsv) {
      csvRef.current.link.click();
      setCsv([]);
      setIsCsv(false);
    }
  }, [csv]);

  // F1 key listener
  useEffect(() => {
    const handleF1 = (event) => {
      if (event.key === "F1") {
        event.preventDefault(); // Prevent default browser refresh
        navigate("add"); // Redirect to add invoice
      }
    };

    window.addEventListener("keydown", handleF1);

    return () => {
      window.removeEventListener("keydown", handleF1);
    };
  }, [navigate]);

  useEffect(() => {
    // find customer filter
    const customerFilter = columnFilters.find(f => f.id === "user");

    // only calculate when customer is searched
    if (!customerFilter || !customerFilter.value) {
      setCreditTotal(0);
      return;
    }

    const rows = invoices.data?.data || [];

    const total = rows.reduce((sum, row) => {
      return sum + Number(Math.round(row.balance_amount) || 0);
    }, 0);

    const roundedTotal = Math.round(total);

    setCreditTotal(roundedTotal);
  }, [columnFilters, invoices.data]);

  return (
    <>
      <CSVLink
        style={{ display: "none" }}
        asyncOnClick={true}
        data={csv}
        filename={filename}
        ref={csvRef}
      ></CSVLink>
      <div style={{ display: "none" }}>
        <InvoicePrintA4 data={invoiceA4} counter={counterData} ref={a4Ref} heading={headingText} />
      </div>
      {isMobileScreen ? (
        <>
          <Select
            p={5}
            label="Counter"
            defaultValue={counter || null}
            placeholder="Select Counter"
            data={countersList || []}
            onChange={setCounter}
            clearable
            disabled={isCounterAdmin()}
          />
        </>
      ) : (
        <Container fluid>
          <Box p={25}>
            <Flex justify={"space-between"} align="end">
              <Box>
                <Text size={"lg"} fw={600} mb={10}>
                  Invoices
                </Text>
                <AppBreadcrumb
                  crumbs={[
                    {
                      text: "Transactions",
                    },
                    {
                      text: "Invoices",
                    },
                  ]}
                />
              </Box>
              <Box>
                <Flex align={"end"} gap={10}>
                  {/* <Button onClick={() => { setModalOpenedBarcode(true) }}>Scan</Button> */}
                  {columnFilters.length === 0 ? (
                    <Tooltip label="Apply at least one column filter to enable CSV export">
                      <span>
                        <Button
                          leftIcon={<IconDownload />}
                        >
                          CSV
                        </Button>
                      </span>
                    </Tooltip>
                  ) : (
                    <Button
                      onClick={() => {
                        if (parseInt(localStorage.getItem("editable_invoices") || 0) > 0) {
                          showErrorToast({
                            title: "Pending Invoices",
                            message: "Pending invoices found! Please complete or clear editable invoices before exporting CSV.",
                          });
                          return;
                        }
                        setIsCsv(true);
                        printFilter();
                      }}
                      leftIcon={<IconDownload />}
                    >
                      CSV
                    </Button>
                  )}
                  {/* <Button
                    leftIcon={<IconPrinter />}
                    onClick={() => {
                      print(true);
                    }}
                  >
                    Print
                  </Button> */}
                  {columnFilters.length === 0 ? (
                    <Tooltip label="Apply at least one column filter to enable Print">
                      <span>
                        <Button
                          leftIcon={<IconPrinter />}
                        >
                          Print
                        </Button>
                      </span>
                    </Tooltip>
                  ) : (
                    <Button
                      onClick={() => {
                        if (parseInt(localStorage.getItem("editable_invoices") || 0) > 0) {
                          showErrorToast({
                            title: "Pending Invoices",
                            message: "Pending invoices found! Please complete or clear editable invoices before printing.",
                          });
                          return;
                        }
                        printFilter();
                      }}
                      leftIcon={<IconPrinter />}
                    >
                      Print
                    </Button>
                  )}
                  {hasPermission("add_invoice") && (
                    <Button
                      onClick={() => {
                        navigate("add");
                      }}
                    >
                      <IconPlus style={{ width: "20px" }} />
                      <Text ml={10}> Create New Invoice (F1)</Text>
                    </Button>
                  )}
                  <Select
                    label="Counter"
                    defaultValue={counter || null}
                    placeholder="Select Counter"
                    data={countersList || []}
                    onChange={setCounter}
                    clearable
                    disabled={isCounterAdmin()}
                  />
                </Flex>
              </Box>
            </Flex>
          </Box>
        </Container>
      )}
      {/* STARTS :: Main content */}

      <Container fluid mt={10} mb={30}>
        {/* Add Product Form */}
        <Box px={isMobileScreen ? 5 : 24} py={10}>
          <Box className="datatable-wrapper" ref={componentRef}>
            <MantineReactTable
              manualFiltering={true}
              onColumnFiltersChange={setColumnFilters} //hoist internal columnFilters state to your state
              state={{ columnFilters, pagination, isLoading: invoices.isLoading || invoices.isRefetching }} //pass in your own managed columnFilters state
              mantineTableProps={{ className: "datatable" }}
              enableRowActions
              positionActionsColumn="last"
              renderTopToolbarCustomActions={({ row }) => {
                const customerFilter = columnFilters.find(f => f.id === "user");

                return (
                  <Box px={isMobileScreen ? 5 : 24} py={10}>
                    <Flex justify="space-between" align="flex-start" mb={6}>
                      {/* LEFT */}
                      <Text
                        fw={600}
                        tt="uppercase"
                        size="sm"
                        sx={theme => ({
                          letterSpacing: 1,
                          color: theme.colors.brand[7],
                        })}
                      >
                        Invoices List
                      </Text>
                      {/* Today's Stats Badges */}
                      <Flex gap="xs" ml="md">
                        {columnFilters.length < 1 &&
                          <>
                            <Badge
                              size="lg"
                              variant="light"
                              color="blue"
                              sx={{ borderRadius: 6 }}
                            >
                              Today's Total Bill: {todayStats.total}
                            </Badge>
                            <Badge
                              size="lg"
                              variant="light"
                              color="orange"
                              sx={{ borderRadius: 6 }}
                            >
                              Today's Pending: {todayStats.pending}
                            </Badge>
                            <Badge
                              size="lg"
                              variant="light"
                              color="yellow"
                              sx={{ borderRadius: 6 }}
                            >
                              Today's Editable: {todayStats.editable}
                            </Badge>
                          </>
                        }
                        {columnFilters.length > 0 ? (
                          <Text fw={700} c="blue">
                            Filter Total: ₹ {(filteredTotal).toLocaleString("en-IN")}
                            {/* <Text span c="dimmed"> {" "} ({100})</Text> */}
                          </Text>
                        ) :  (
                          <Text fw={600} c="white">
                            Today's Total: ₹ {(todayTotal).toLocaleString("en-IN")}
                            {/* <Text span c="dimmed"> {" "} ({100})</Text> */}
                          </Text>
                        )}
                      </Flex>


                      {/* RIGHT – show only when customer searched */}
                      {/* {customerFilter?.value && (
          <Box  mr={0} ml={288}>
          <Badge
            fz="12px"
            fw="bold"
            variant="light"
            color="red"
            sx={{
              borderRadius: 20,
            }}
          >
            TOTAL CREDIT (₹ {creditTotal.toFixed(2)})
          </Badge>
          </Box>
        )} */}
                    </Flex>
                  </Box>
                );
              }}
              renderRowActions={({ row }) => {
                console.log('qqq-009', row)
                return (
                  <Flex>
                    <Tooltip label="Mark as delivered" disabled={row.original.delivered}>
                      <ActionIcon
                        disabled={true}
                        sx={theme => ({ color: theme.colors.brand[7] })}
                        onClick={() => {
                          if (!row.original.delivered) {
                            openDeliveryConfirmation(row.original.id);
                            // navigate(`print/?id=${row.original.id}`);
                          }
                        }}
                      >
                        <IconTruckDelivery style={{ width: 20 }} />
                      </ActionIcon>
                    </Tooltip>
                    {row.original?.order !== null ? (
                      <Tooltip label="View Order">
                        <ActionIcon
                          ml={10}
                          sx={theme => ({ color: theme.colors.brand[7] })}
                          onClick={() => {
                            navigate(`/orders/view?id=${row.original?.order}`);
                          }}
                        >
                          <IconBoxSeam style={{ width: 20 }} />
                        </ActionIcon>
                      </Tooltip>
                    ) : (
                      <></>
                    )}
                    <Tooltip label="Print Invoice">
                      <ActionIcon
                        ml={10}
                        sx={theme => ({ color: theme.colors.brand[7] })}
                        onClick={() => {
                          // navigate(`print/?id=${row.original.id}`);
                          // const pdfUrl = `https://dev.quzone.in/api/print_invoice/?invoice_id=${row.original.id}`;
                          // window.open(pdfUrl, '_blank');
                          printInvoice(row.original.id, row.original.delivered);
                        }}
                      >
                        <IconPrinter style={{ width: 20 }} />
                      </ActionIcon>
                    </Tooltip>
                    <Tooltip label="Print Invoice A4">
                      <ActionIcon
                        ml={10}
                        sx={theme => ({ color: theme.colors.brand[7] })}
                        onClick={() => {
                          printInvoiceA4(row.original.id, row.original.delivered);
                        }}
                      >
                        <IconFile style={{ width: 20 }} />
                      </ActionIcon>
                    </Tooltip>
                    <Tooltip label="View Payment Receipt">
                      <ActionIcon
                        sx={theme => ({ color: theme.colors.brand[7] })}
                        ml={10}
                        onClick={() => {
                          setInvoiceId(row.original.id);
                          setSelectedInvoice(row.original);
                          setViewPaymentReceiptId(row.original);
                          setViewPaymentReceiptModalOpened(true);
                        }}
                      >
                        <IconCash style={{ width: 20 }} />
                      </ActionIcon>
                    </Tooltip>
                    <Tooltip label="Add Payment Receipt">
                      <ActionIcon
                        disabled={Number((row?.original?.balance_amount || 0).toFixed(0)) < 1 ? true : false}
                        sx={theme => ({ color: theme.colors.brand[7] })}
                        ml={10}
                        onClick={() => {
                          setInvoiceId(row.original.id);
                          setSelectedInvoice(row.original);
                          setaddPaymentReceiptOpened(true);
                        }}
                      >
                        <IconCirclePlus style={{ width: 20 }} />
                      </ActionIcon>
                    </Tooltip>

                    {hasPermission("change_invoice") ? (
                      <Tooltip label="Edit Invoice">
                        <ActionIcon
                          disabled={row.original.delivered}
                          sx={theme => ({ color: theme.colors.brand[7] })}
                          ml={10}
                          onClick={() => {
                            navigate(`edit?id=${row.original.id}`);
                          }}
                        >
                          <IconEdit style={{ width: 20 }} />
                        </ActionIcon>
                      </Tooltip>
                    ) : (
                      ""
                    )}
                    <Tooltip label="View Invoice">
                      <ActionIcon
                        sx={theme => ({ color: theme.colors.brand[7] })}
                        ml={10}
                        onClick={() => {
                          navigate(`view?id=${row.original.id}`);
                        }}
                      >
                        <IconEye style={{ width: 20 }} />
                      </ActionIcon>
                    </Tooltip>

                    {hasPermission("delete_invoice") && (
                      <Tooltip label="Delete Invoice">
                        <ActionIcon
                          disabled={row.original.delivered}
                          sx={theme => ({ color: theme.colors.red[6] })}
                          ml={10}
                          onClick={() => {
                            openDeleteConfirmation(row.original.id);
                          }}
                        >
                          <IconTrash style={{ width: 20 }} />
                        </ActionIcon>
                      </Tooltip>
                    )}
                  </Flex>
                )
              }
              }
              initialState={{ density: "xs" }}
              columns={columns}
              enableDensityToggle={false}
              enableFullScreenToggle={false}
              enableColumnActions={false}
              data={invoices.data?.data || []}
              enableStickyHeader
              enableGlobalFilter={false}
              isLoading={invoices.isLoading || invoices.isRefetching}
              onPaginationChange={(updater) => {
                setPagination((prev) => {
                  const newPagination = typeof updater === "function" ? updater(prev) : updater;
                  return { ...prev, ...newPagination };
                });
              }}
              rowCount={invoices.data?.count}
              manualPagination
            />
          </Box>
        </Box>
      </Container>

      {/* ENDS :: Main content */}

      <Modal
        opened={modalOpenedBarcode}
        onClose={() => {
          setModalOpenedBarcode(false);
        }}
        title={
          <Box px={10}>
            <Text fw={600}>Scan Barcode</Text>
          </Box>
        }
        centered
      >
        <Box px={10}>
          <Divider mb={20} />

          <BarcodeScannerComponent
            width={500}
            height={500}
            onUpdate={(err, result) => {
              if (result) setBarcodeData(result.text);
              else setBarcodeData("Not Found");
            }}
          />
          <Text>{barcodeData}</Text>
        </Box>
      </Modal>

      {viewPaymentReceiptModalOpened && (
        <ViewPaymentReceipts
          opened={viewPaymentReceiptModalOpened}
          onClose={() => {
            setViewPaymentReceiptModalOpened(false);
          }}
          invoiceId={invoiceId}
          invoiceData={selectedInvoice}
        // viewPaymentReceiptId={viewPaymentReceiptId}
        // viewPaymentReceiptModalOpened={viewPaymentReceiptModalOpened}
        // setViewPaymentReceiptModalOpened={setViewPaymentReceiptModalOpened}
        />
      )}

      {addPaymentReceiptOpened && (
        <AddPaymentReceipt
          opened={addPaymentReceiptOpened}
          onClose={() => {
            setaddPaymentReceiptOpened(false);
            setTimeout(() => {
              invoices.refetch()
            }, 500);
          }}
          invoiceId={invoiceId}
          defaultData={selectedInvoice}
          fromInvoice={true}
        />
      )}
      <div style={{ display: "none" }}>
        <PrintModal
          cols={[3]}
          title="Invoices"
          head={head}
          body={body}
          foots={foot}
          ref={componentRef}
        />
      </div>

      {hasPermission("add_invoice") && isMobileScreen ? (
        <>
          <FloatingMenu
            m={5}
            ml={60}
            left
            size={50}
            onClick={() => {
              if (columnFilters.length === 0) return;
              if (parseInt(localStorage.getItem("editable_invoices") || 0) > 0) {
                showErrorToast({
                  title: "Pending Invoices",
                  message: "Pending invoices found! Please complete or clear editable invoices before exporting CSV.",
                });
                return;
              }
              setIsCsv(true);
              printFilter();
            }}
          >
            <IconDownload color="white" />
          </FloatingMenu>
          <FloatingMenu
            m={5}
            right
            size={50}
            onClick={() => {
              navigate("add");
            }}
          >
            <IconPlus color="white" />
          </FloatingMenu>
          <FloatingMenu
            m={5}
            left
            size={50}
            onClick={() => {
              if (columnFilters.length === 0) return;
              if (parseInt(localStorage.getItem("editable_invoices") || 0) > 0) {
                showErrorToast({
                  title: "Pending Invoices",
                  message: "Pending invoices found! Please complete or clear editable invoices before printing.",
                });
                return;
              }
              printFilter();
            }}
          >
            <IconPrinter color="white" />
          </FloatingMenu>
        </>
      ) : (
        <></>
      )}
    </>
  );
}


